import { DatePicker, Modal, Radio } from 'antd';
import { Button } from 'components/Button';
import { Heading } from 'components/Typography';
import React, { useEffect, useState } from 'react';
import moment from 'moment';

function DownloadInvoiceModal({ isDownloadInvoiceVisible, setDownloadInvoiceVisible, downloadInvoices, deleteZipFile, user }) {
    const [value, setValue] = useState(0);
    const [dateRange, setDateRange] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [downloadLoader, setDownloadLoader] = useState(false);

    const handleCancel = () => {
        setDownloadInvoiceVisible(false)
    }
    const onRadioChange = (e) => {
        setValue(e.target.value);
    };
    const handleDownload = () => {
        const params = {
            userId : user.id,
            type: "Student Fee",
            dateRange,
            startDate,
            endDate
        }
        setDownloadLoader(true),
        downloadInvoices(params, () =>{setDownloadLoader(false)} ,(val)=>{setDownloadInvoiceVisible(false);deleteZipFile(val)}  )
      }

    useEffect(() => {
        setDateRange(null);
        setStartDate(null);
        setEndDate(null);
      }, []);

      function disabledDate(current) {
        return (
          current >= moment().endOf("day") || current <= moment(startDate)
        );
      }
    
      function disabledstartDate(current) {
        return current >= moment().endOf("day");
      }

    const RangeStyle = {
        font: "normal normal normal 15px/21px Roboto",
        color: "#191919",
        margin: "5px",
    };

    return (
        <Modal
            centered
            className="modal-round-corner"
            visible={isDownloadInvoiceVisible}
            onCancel={handleCancel}
            header={null}
            footer={null}
        >
            <Heading bold className='r-c-c m-t-10'>Select range</Heading>
            <div style={{ height: 400 }}>
                <div
                    style={{
                        color: "#191919",
                        fontSize: "14px",
                        fontWeight: 600,
                        padding: "10px",
                    }}
                >
                    <Radio.Group
                        onChange={onRadioChange}
                        value={value}
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                        }}
                    >
                        <Radio
                              onClick={() => {setDateRange("lastWeek")}}
                            value={1}
                            style={{ marginTop: "20px" }}
                        >
                            <div style={RangeStyle}>Last week</div>
                        </Radio>
                        <Radio 
                        onClick={() => {setDateRange("lastMonth")}} 
                        value={2}
                        >
                            <div style={RangeStyle}>Last month</div>
                        </Radio>
                        <Radio
                            onClick={() => {setDateRange("lastThreeMonths")}}
                            value={3}
                        >
                            <div style={RangeStyle}>Last 3 month</div>
                        </Radio>
                        <Radio
                            onClick={() => {setDateRange("lastSixMonths")}}
                            value={4}
                        >
                            <div style={RangeStyle}>Last 6 month</div>
                        </Radio>
                        <Radio
                            onClick={() => {setDateRange("currentYear")}}
                            value={5}
                        >
                            <div style={RangeStyle}>Year to date</div>{" "}
                        </Radio>
                        <Radio
                            onClick={() => {
                                setValue(6);
                                 setDateRange("custom");
                            }}
                            value={6}
                        >
                            <div style={RangeStyle}>Specific date range</div>
                        </Radio>
                    </Radio.Group>
                </div>

                {value === 6 ? (
                    <div
                        className="flex-row"
                        style={{ justifyContent: "space-around", marginTop: "10px" }}
                    >
                        <div>
                            <div style={{ color: "#636363", fontSize: "13px" }}>
                                Start date
                            </div>
                            <div>
                                <DatePicker
                                 format={"DD/MM/YYYY"}
                                    allowClear={false}
                                    style={{ width: "200px" }}
                                    onChange={(e) => setStartDate(e.format("YYYY-MM-DD"))}
                                    disabledDate={disabledstartDate}
                                />
                            </div>
                        </div>
                        <div>
                            <div style={{ color: "#636363", fontSize: "13px" }}>End date</div>
                            <div>
                                <DatePicker
                                 format={"DD/MM/YYYY"}
                                    allowClear={false}
                                    disabled={startDate === null ? true : false}
                                    style={{ width: "200px" }}
                                  onChange={(e) => setEndDate(e.format("YYYY-MM-DD"))}
                                  disabledDate={disabledDate}
                                />
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    marginTop: "40px",
                    marginBottom: 10
                }}>
                <Button
                    style={{
                        borderRadius: "19px",
                        width: "120px",
                        height: "35px",
                        border: "1px solid  #636363",
                        backgroundColor: "#FFFFFF",
                        color: "#594099",
                        marginLeft: 50
                    }}
                    onClick={handleCancel}>
                    CANCEL
                </Button>
                <Button
                    disabled={
                        value === 6
                          ? value === 0 ||
                            startDate === null ||
                            endDate === null
                            ? true
                            : false
                          : value === 0
                          ? true
                          : false
                      }
                    style={{
                        borderRadius: "19px",
                        width: "120px",
                        height: "35px",
                        marginRight: 50,
                        opacity:
                value === 6
                  ? value === 0 ||
                    startDate === null ||
                    endDate === null
                    ? 0.5
                    : 1
                  : value === 0
                  ? 0.5
                  : 1,
                    }}
                    type='primary'
                    onClick={handleDownload} 
                    loading={downloadLoader}
                    >
                    DOWNLOAD
                </Button>
            </div>
        </Modal>
    )
}

export default DownloadInvoiceModal